import React from "react";
import ThreeSections from "./Section";
import Compare from "./Compare";
import HeadImg from "../../../assets/Exactness/Header/Bg.svg";
import FaqSection from "./FaqSection";
import { useNavigate, useParams } from "react-router-dom";

const ComparisonDisplay = () => {
  const { topic } = useParams();
  const navigate = useNavigate();

  const generateHeadingAndText = (topic) => {
    switch (topic) {
      case "Anymail_Finder":
        return {
          heading:
            '<span class="text-[#00408C]">Exact Mails</span> vs. Anymail Finder',
          text: "Why teams choose ExactMails for accurate, hassle-free email discovery",
        };
      case "Email_Hunter":
        return {
          heading:
            '<span class="text-[#00408C]">Exact Mails</span> vs. Email Hunter',
          subheading: "Ensuring precision with seamless bulk processing.",
          text: "Why teams trust us for accurate, hassle-free email discovery",
        };
      case "Get_Prospect":
        return {
          heading:
            '<span class="text-[#00408C]">Exact Mails</span> vs. Get Prospect',
          subheading: "Achieve top accuracy and effortless bulk handling.",
          text: "Understand how Exact Mails elevates your email discovery and verification with robust features.",
        };
      case "ProsPio":
        return {
          heading:
            '<span class="text-[#00408C]">Exact Mails</span> vs. ProsPio',
          subheading: "Delivering accuracy and easy bulk processing.",
          text: "Find out how Exact Mails can revolutionize your email verification process with outstanding accuracy and efficiency.",
        };
      default:
        return {
          heading: `<span class="text-[#00408C]">Exact Mails</span> vs. FindyEmail`,
          subheading:
            "Get better accuracy and hassle-free bulk email processing.",
          text: `See how Exact Mails transforms email verification with precision and efficiency.`,
        };
    }
  };

  const { heading, subheading, text } = generateHeadingAndText(topic);

  const handlenav = () => {
    window.location.href = process.env.REACT_APP_BASE_URL;
  };

  return (
    <>
      <div className="relative flex h-[80vh] min-[420px]:h-[70vh] min-[500px]:h-[60vh] md:h-[57vh] flex-col 2xl:h-[45vh] 3xl:h-[35vh]">
        <img
          src={HeadImg}
          alt="Header Background"
          className="absolute bottom-0 left-0 h-[80vh] min-[420px]:h-[70vh] min-[500px]:h-[60vh] md:h-[57vh] 2xl:h-[45vh] 3xl:h-[35vh] w-full object-cover"
        />
        <div className="flex flex-col items-center justify-center pt-5 min-[450px]:pt-14 relative z-10">
          <div className="text-center max-w-full px-8 md:px-10 lg:px-10">
            <p className="text-xl text-[1.7rem] font-medium leading-[1.67] text-gray-700">
              COMPARISON
            </p>
            <h1
              className="text-3xl lg:text-[37px] font-semibold text-center mt-2 !leading-[1.25]"
              dangerouslySetInnerHTML={{ __html: heading }}
            />
            <div className="flex justify-center items-center">
              <h1 className="text-3xl lg:text-[37px] font-semibold text-center xl:text-nowrap !leading-[1.25]">
                <span
                  className="text-black"
                  dangerouslySetInnerHTML={{ __html: subheading }}
                />
              </h1>
            </div>
            <p
              className="sm:text-lg text-md text-gray-400 mb-5 mt-3"
              dangerouslySetInnerHTML={{ __html: text }}
            />
            {topic === "Anymail_Finder" && (
              <div className="text-center w-full flex justify-center gap-4 mb-4">
                <button
                  onClick={handlenav}
                  className="text-white bg-background mt-6 lg:mt-10 hover:bg-hover font-semibold p-3 rounded-md hover:text-white w-[220px]"
                >
                  Try Free for 3 Days
                </button>
                <button
                  onClick={() => navigate("/pricing")}
                  className="text-white bg-background mt-6 lg:mt-10 hover:bg-hover font-semibold p-3 rounded-md hover:text-white w-[220px]"
                >
                  See Pricing
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <ThreeSections />
      <Compare />
      <FaqSection />
    </>
  );
};

export default ComparisonDisplay;
